import React from 'react'
import Dashboard from '../Dashboard';
import ApplicationCenterMain from './ApplicationCenterMain'

export default function ApplicationCenter() {
    return (
        <div>
            <Dashboard cmp={<ApplicationCenterMain />} />
        </div>
    )
}
